// extracted by mini-css-extract-plugin
module.exports = {"accordions":"accordions__3OPxC"};